export default __webpack_public_path__ + "static/media/pause_timer.72056d95.svg";